<div class="modal-header">
    <h4 class="modal-title">Demandes de tickets</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div *ngIf="loading">
        <span class="button-loader"></span>
        Chargement des demandes…
    </div>

    <div *ngIf="error" class="alert alert-danger">
        {{ error }}
    </div>

    <div *ngIf="!loading && !error && !requests.length" class="alert alert-info">
        Aucune demande de tickets pour le moment.
    </div>

    <table *ngIf="!loading && !error && requests.length" class="table table-striped">
        <thead>
            <tr>
                <th scope="col">Date</th>
                <th *ngIf="showCenterColumn" scope="col">Centre</th>
                <th scope="col">Quantité</th>
                <th scope="col">Session</th>
                <th scope="col">Statut</th>
                <th scope="col">Facture</th>
                <th scope="col">Commentaire</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let request of requests">
                <td>{{ request.created_date | date:'dd/MM/yyyy' }}</td>
                <td *ngIf="showCenterColumn">{{ request.exam_center?.nom }}</td>
                <td>{{ request.quantity }}</td>
                <td>
                    <span *ngIf="request.session">{{ request.session.code }}</span>
                    <span *ngIf="!request.session" class="text-muted">—</span>
                </td>
                <td>
                    <span class="badge" [ngClass]="request.statusBadgeClass">
                        {{ request.statusLabel }}
                    </span>
                </td>
                <td>
                    <span *ngIf="request.invoice">{{ request.invoice.label }}</span>
                    <span *ngIf="!request.invoice" class="text-muted">—</span>
                </td>
                <td>
                    <span *ngIf="request.comment">{{ request.comment }}</span>
                    <span *ngIf="!request.comment" class="text-muted">—</span>
                </td>
            </tr>
        </tbody>
    </table>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-success" (click)="activeModal.dismiss()">Ok</button>
</div>
